import React, { ReactElement } from 'react';
import { t } from '@sm/intl';
import { Container, Typography } from '@sm/wds-react';
import { createSurveyStyles } from '@sm/webassets';
import COPY from '~app/pages/EnterpriseThankYou/copy';
import { HeaderTextPropsType, HeaderTypeEnum } from '../../types';
import { evaluateTextColorVisibility, getThemeColors } from '~app/pages/EnterpriseThankYou/helpers/themeColors';

const useStyles = createSurveyStyles(theme => {
  const { headerTextColor, bodyTextColor, backgroundColor } = getThemeColors(theme);
  const visibleColor = evaluateTextColorVisibility(headerTextColor, bodyTextColor, backgroundColor);
  return {
    headerText: {
      color: visibleColor,
      fontFamily: theme?.pageTitle?.fontFamily,
    },
  };
});

const Text = ({ text, headerType }: HeaderTextPropsType): ReactElement => {
  const { headerText } = useStyles();
  const hasText = !!`${text}`.trim();
  const allowCustomText = headerType === HeaderTypeEnum.PREMIUM;
  const resultText = hasText && allowCustomText ? text : t(COPY.THANK_YOU);

  return (
    <Container className="sm-enterprise-thank-you__header-text" flex flexJustify="center">
      <Typography
        data-testid="Text__Header"
        className={`sm-enterprise-thank-you__header-text-inner ${allowCustomText ? headerText : ''}`}
        component="h1"
        align="center"
        color="dark"
      >
        {resultText}
      </Typography>
    </Container>
  );
};

export default Text;
